(function () {
  'use strict';

  if (customElements.get('product-sticky-media')) return;

  const DESKTOP_BREAKPOINT = 1024;
  const EDGE_GAP = 24;

  class ProductStickyMedia extends HTMLElement {
    constructor() {
      super();
      this.frame = null;
      this.handleViewportChange = this.scheduleUpdate.bind(this);
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.details = this.productInfo?.querySelector('.product-single__details');
      if (!this.productInfo || !this.details) return;

      window.addEventListener('resize', this.handleViewportChange, {passive: true});
      document.addEventListener('theme:resize', this.handleViewportChange);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleViewportChange);
        this.resizeObserver.observe(this);
        this.resizeObserver.observe(this.details);
      }

      this.scheduleUpdate();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleViewportChange);
      document.removeEventListener('theme:resize', this.handleViewportChange);
      this.resizeObserver?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }

    scheduleUpdate() {
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updatePosition();
      });
    }

    headerOffset() {
      const heights = window.theme?.readHeights?.() || {};
      const header = document.querySelector('[data-header-height]');
      const currentHeaderHeight = heights.stickyHeaderHeight || heights.headerHeight || header?.getBoundingClientRect().height || 0;
      return Math.max(0, Math.round(currentHeaderHeight)) + EDGE_GAP;
    }

    updatePosition() {
      const galleryHeight = this.offsetHeight;
      const detailsHeight = this.details?.offsetHeight || 0;
      const topLimit = this.headerOffset();
      const availableHeight = window.innerHeight - topLimit - EDGE_GAP;
      const enabled =
        window.innerWidth >= DESKTOP_BREAKPOINT &&
        detailsHeight > galleryHeight &&
        galleryHeight <= availableHeight;

      if (!enabled) {
        this.classList.remove('is-sticky');
        this.style.removeProperty('--product-gallery-sticky-top');
        return;
      }

      this.style.setProperty('--product-gallery-sticky-top', `${topLimit}px`);
      this.classList.add('is-sticky');
    }
  }

  customElements.define('product-sticky-media', ProductStickyMedia);
})();
